import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from '@/auth/useAuth';
import { ROUTES } from '@/constants/routes';
import { LoadingLayout } from '@/layouts/LoadingLayout';

/** For login/register/forgot-password — an already-authenticated user is bounced to the app root, not shown the form again. */
export function GuestRoute() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) return <LoadingLayout />;
  if (isAuthenticated) return <Navigate to={ROUTES.root} replace />;

  return <Outlet />;
}
